import React from 'react'
import ButtonComponent from '../../../../components/Buttons/ButtonComponent'
import TableEPL from '../TableEPL/TableEPL';
import { Grid, Stack } from '@mui/material';
import { showToast } from '../../../../components/ui';

const TabIncConsignee = (props) => {
  const title = 'Inc Consignee'
  const contactTypeName = 'Consignee'
  const contactTypeId = 3
  const income = true

  const handleAdd = () => {
    if (props.shipmentNo !== '') {
      props.handleAdd(title, contactTypeName, contactTypeId, income)
    }
    else {
      showToast({ type: 'error', message: 'Please Select Shipment Number First!' });
    }
  }

  const handleEdit = () => {
    if (props.selectedDetailIncConsignee.sequence === undefined) {
      showToast({ type: 'error', message: 'Please Select Data!' });
    } else {
      props.handleEdit(title, contactTypeName, contactTypeId, income)
    }
  }

  const handleConvert = () => {
    if (props.selectedDetailIncConsignee.sequence === undefined) {
      showToast({ type: 'error', message: 'Please Select Data!' });
    } else {
      props.handleConvert(title, contactTypeName, contactTypeId, income)
    }
  }

  const handleDoubleClick = () => {
    handleEdit()
  }

  const handleDelete = () => {
    if (props.selectedDetailIncConsignee.bookingDetailId === 0) {
      props.handleDelete(contactTypeId, income)
    }
    else {
      showToast({ type: 'error', message: 'Can\'t Delete This Data!' });
    }
  }

  return (
    <div className='rounded-10'>
      <TableEPL
        key={2}
        isReadOnly={props.isReadOnly}
        dataList={props.IncConsigneeList}
        ignoreAccess={props.ignoreAccess}
        setDataList={props.setIncConsigneeList}
        setSelectedDetail={props.setSelectedDetailIncConsignee}
        selectedDetail={props.selectedDetailIncConsignee}
        handleDoubleClick={handleDoubleClick}
        contactTypeName={contactTypeName}
        ttlUsd={props.estIncUSDConsignee}
        ttlIdr={props.estIncIDRConsignee}
        totalSData={props.totalIncSConsignee}
        totalNData={props.totalIncNConsignee}
        key1={2}
        key2={2}
        type={1}
        openClose={props.openCloseIC}
        setOpenClose={props.setOpenCloseIC}
        openClose2={props.openCloseIC2}
        setOpenClose2={props.setOpenCloseIC2}
        dataDetail={props.dataDetail}
        setDataDetail={props.setDataDetail}
        countSum={props.countSum}
        countTotalData={props.countTotalData}
      />

      <Grid container item direction="row" className='mt-3'>
        <Grid item xs={10}>
          <Stack direction={'row'} spacing={'10px'}>
            {ButtonComponent.AddButton(handleAdd, '', props.isReadOnly)}
            {ButtonComponent.EditButton(handleEdit, '', props.isReadOnly)}
            {ButtonComponent.DeleteButton(handleDelete, '', props.isReadOnly)}
            {ButtonComponent.ConvertButton(handleConvert, props.isReadOnly, true)}
            {ButtonComponent.DemurrageButton(props.handleDemurrage, true, props.isReadOnly)}
          </Stack>
        </Grid>

        <Grid item xs={2} className='text-end' display={'flex'} justifyContent={'flex-end'}>
          {ButtonComponent.AddButton(() => props.handleAddSt(title, contactTypeName, contactTypeId, income), 'Storage', props.isReadOnly, true)}
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(TabIncConsignee)